import { LogAttivitaService } from './services/logattivita.service';
import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';
import { RequestBuilder } from './classes/request-builder';
import { Loading } from './utils/loading';
import { AlertUtil } from './utils/alert-util';
import * as Enum from './utils/enums'
import * as Constants from './utils/constants';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']//,encapsulation: ViewEncapsulation.None
})
export class AppComponent {
  title = 'legalileo';
  isLogged = false
  userGuid: string //user guid

  constructor(private translate: TranslateService,
    private logAttivitaService:LogAttivitaService,
    private alertUtil: AlertUtil) {
    let browserLang = translate.getBrowserLang();
    translate.addLangs(["it", "en"]);
    translate.setDefaultLang('it');
    translate.use(browserLang.match(/it|en/) ? browserLang : 'it')
    this.userGuid = localStorage.getItem(Constants.LS_USER_GUID)
  }

  ngOnInit() { }

  authorizationEmitter(obj: boolean){
    if(!obj){ //if Logout
      this.callSaveLog(obj)
    }else{
      this.isLogged = obj 
    }
  }

  /**
   * call save log for logout
   */
  callSaveLog(obj: boolean){
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder(this.getPayloadFilter())
    this.logAttivitaService.saveLog(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.isLogged = obj 
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * payload for save log
   */
  getPayloadFilter() {
    //filtro lato BE
    let payload: any = {
      User: this.userGuid,
      Operazione: Enum.OPERAZIONI_ENUM.LOGOUT,
      IdEntity: "",
      Entity: "",
      Oldvalue:"",
      NewValue: ""
    }
    return payload
  }

}